// extracted by mini-css-extract-plugin
export default {"addToCartControl":"bZ-z","giftCard":"cZ-z","btnContainer":"dZ-z","cartButton":"eZ-z","disabled":"fZ-z"};